/** @jsx jsx */
import { jsx, css } from "@emotion/core"

type Props = {
    children: string
}

function PageTitle({ children }: Props) {
    return <h1 css={styles.title}>{children}</h1>
}

export default PageTitle

const styles = {
    title: css`
        text-align: center;
        font-weight: 600;
    `,
}
